<div class="page-title-area">
  <div class="d-table">
      <div class="d-table-cell">
          <div class="container">
              <div class="page-title-text">
                  <h2>{{title}}</h2>
                  <ul>
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li><a [routerLink]="['/profile', user.id]">Profile Detail</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li>Service Handle</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>




<div class="dashboard-area pt-100">
  <div class="container">
      <div class="create-information">
          <form [formGroup]="hform" (ngSubmit)="saveData()">
              <h3>{{title}}</h3>

              <div class="row">

                   <div class="row">
                     <!-- Handle Type -->
                     <div class="col-lg-6">
                      <div class="form-group">
                          <label for="handleTypeId">Select Handle</label>
                          <ng-select
                          formControlName="handleTypeId"
                          [ngClass]="{'is-invalid': displayMessage.handleTypeId}"
                          [items]="handleTypes"
                          bindLabel="detail"
                          bindValue="id">
                          </ng-select>
                          <span class="invalid-feedback">
                            {{displayMessage.handleTypeId}}
                          </span>
                      </div>
                    </div>

                    <!-- Handle Detail -->
                    <div class="col-lg-6">
                      <div class="form-group">
                          <label for="handleDetail">Handle Name</label>
                          <input type="text" class="form-control"
                          id="handleDetail" placeholder="Copy Link from selected handle app and paste here"
                          formControlName="handleDetail"
                          [ngClass]="{'is-invalid': displayMessage.handleDetail }">
                          <span class="invalid-feedback">
                            {{displayMessage.handleDetail}}
                          </span>
                      </div>
                    </div>

                   </div>
              </div>

              <div class="text-left">
                <button type="submit" class="btn create-ac-btn"
                  [title]="hform.valid"
                  [disabled]="!hform.valid">
                  Add
                  <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                </button>
              </div>

          </form>
      </div>

  </div>
</div>


<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#40a834" type = "line-scale" [fullScreen] = "true">
  <p style="color: rgb(250, 242, 242)" > Loading... </p>
</ngx-spinner>
